import { seedForgeOutputSchemas } from './seedForgeOutputSchemas';

/**
 * Registers Forge output schemas for the process registry.
 */
export default function initSchema(): void {
  seedForgeOutputSchemas();
}
